import { render, staticRenderFns } from "./AddEventPage.vue?vue&type=template&id=ec64ad16&"
import script from "./AddEventPage.vue?vue&type=script&lang=js&"
export * from "./AddEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports